import React, { useState } from 'react';

const faqs = [
  { q: 'Is REVIVE free to attend?', a: 'Yes. REVIVE is completely free. There is no ticket, no registration fee, and no charge at the door. Come as you are.' },
  { q: 'What should I expect at the event?', a: 'A one-night rally including Spirit-filled worship, the ministry of the Word, an altar call (salvation, rededication, healing, Holy Spirit infilling), and a call for the harvest workforce. Expect an encounter — not just an experience.' },
  { q: 'Is this a church event?', a: 'REVIVE is an interdenominational rally for anyone who loves God or is searching for Him. You do not have to belong to any church or ministry to attend. All are welcome.' },
  { q: 'What is the age range?', a: 'REVIVE is designed for ages 15–35, but no one is turned away. If you\'re hungry for God, you belong here.' },
  { q: 'How do I volunteer?', a: 'Use the registration form and select "Volunteer" as your registration type, or scroll up to the Get Involved section. We\'ll reach out with your city\'s specific needs and roles.' },
  { q: 'Can I bring my cell group or ministry?', a: 'Absolutely. Group leaders can register via the form and select "I\'d like to bring a group" to discuss group coordination, transportation, and how to partner your ministry with REVIVE in your city.' },
  { q: 'Where are the venues?', a: 'Venues are currently being confirmed for each city. Register now to receive your city\'s venue details directly to your inbox as soon as they are announced.' },
  { q: 'How can I support REVIVE financially?', a: 'REVIVE is free because of generous partners. You can give via Zelle to gc.boundlessgroup@gmail.com, or use the Partner With Us section to sow into the work. Every city reached is a seed you planted.' },
  { q: 'Will the events be livestreamed?', a: 'Yes. Each REVIVE event will be livestreamed. Register to receive the live link for your city\'s event directly to your email.' },
  { q: 'What happens after I make a decision at the altar call?', a: 'Every person who responds at the altar call is connected with a follow-up team and enrolled in a free Foundation School course to begin their discipleship journey. You will not be left on your own.' },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);
  const half = Math.ceil(faqs.length / 2);

  const Item = ({ faq, idx }) => (
    <div style={{ borderBottom: '1px solid rgba(200,68,10,0.12)', marginBottom: 24, paddingBottom: 24 }}>
      <button onClick={() => setOpen(open === idx ? null : idx)}
        style={{ width: '100%', background: 'none', border: 'none', textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16 }}>
        <span style={{ fontFamily: 'var(--font-body)', fontSize: 15, fontWeight: 500, color: 'var(--white)', lineHeight: 1.5 }}>{faq.q}</span>
        <span style={{ fontSize: 22, color: 'var(--ember)', flexShrink: 0, lineHeight: 1, marginTop: 2, transition: 'transform 0.3s', transform: open === idx ? 'rotate(45deg)' : 'rotate(0)' }}>+</span>
      </button>
      <div style={{
        maxHeight: open === idx ? 300 : 0,
        overflow: 'hidden',
        transition: 'max-height 0.4s ease',
      }}>
        <p style={{ fontSize: 14, color: 'rgba(245,240,232,0.5)', lineHeight: 1.8, marginTop: 14 }}>{faq.a}</p>
      </div>
    </div>
  );

  return (
    <section id="faq" style={{ background: 'var(--ash)', padding: '120px 64px' }}>
      <style>{`
        @media(max-width:900px){ #faq{padding:80px 24px!important;} .faq-grid{grid-template-columns:1fr!important;} }
      `}</style>

      <p className="reveal" style={{ fontSize: 10, letterSpacing: '0.35em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 20 }}>Questions</p>
      <h2 className="reveal" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(48px,6vw,80px)', lineHeight: 0.95, color: 'var(--white)', marginBottom: 24 }}>
        FREQUENTLY<br />ASKED
      </h2>
      <div className="reveal" style={{ width: 48, height: 3, background: 'linear-gradient(90deg,var(--ember),var(--gold))', margin: '0 0 64px' }} />

      <div className="faq-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 80px' }}>
        <div className="reveal">
          {faqs.slice(0, half).map((faq, i) => <Item key={i} faq={faq} idx={i} />)}
        </div>
        <div className="reveal reveal-d2">
          {faqs.slice(half).map((faq, i) => <Item key={i + half} faq={faq} idx={i + half} />)}
        </div>
      </div>
    </section>
  );
}
